import React from 'react';
import PropTypes from 'prop-types';
//style
import 'bootstrap/dist/css/bootstrap.css';
import '../signupbutton/signupbutton.styl'

class LogoutButton extends React.Component {

  logout = () => {
  	localStorage.removeItem('token');
    localStorage.removeItem('name');
    this.context.router.history.push('/');
  }

  render(){
    return (
      <button onClick={this.logout} className='btn btn-primary'>Log out</button>
    );
  }
}

LogoutButton.contextTypes = {
  router: PropTypes.object.isRequired
}
export default LogoutButton;



// WEBPACK FOOTER //
// ./src/components/logoutbutton/LogoutButton.js